import React, { useEffect } from 'react';
import { Form, Input, Button } from 'antd';
import { login } from "../../redux/auth/actions";
import { useDispatch, useSelector } from "react-redux";
import { ClientContainer, Client_photoProfile, div_body } from './styles';
import homepic from './unnamed.jpg';
import { useHistory } from "react-router-dom";

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
};

function LoginForm() {
    const dispatch = useDispatch();
    const history = useHistory(); // Access history for redirection
    const auth = useSelector(state => state.auth); // Get auth state from Redux

    const [form] = Form.useForm();

    const onFinish = (values) => {
        const { email, password } = values;
        dispatch(login({ email, password }));
    };

    const onFinishFailed = (errorInfo) => {
        console.error('Failed:', errorInfo);
    };

    useEffect(() => {
        if (auth.isAuthenticated) {
            history.push('/'); // Redirect to home if authenticated
        } else if (auth.error) {
            form.resetFields(); // Reset form fields if login fails
        }
    }, [auth, history, form]);

    return (
        <div style={{
            height: window.innerHeight,
            width: window.innerWidth,
            backgroundImage: `url(${homepic})`,
            backgroundAttachment: 'fixed',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
        }}>
            <div_body>
                <Client_photoProfile>
                    <ClientContainer>
                        <Form
                            {...layout}
                            form={form}
                            name="basic"
                            initialValues={{ remember: true }}
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                        >
                            <Form.Item
                                label="Username"
                                name="email"
                                rules={[{ required: true, message: 'Please input your username!' }]}
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                label="Password"
                                name="password"
                                rules={[{ required: true, message: 'Please input your password!' }]}
                            >
                                <Input.Password />
                            </Form.Item>

                            <Form.Item {...tailLayout}>
                                <Button type="primary" htmlType="submit">
                                    Login
                                </Button>
                            </Form.Item>
                        </Form>
                    </ClientContainer>
                </Client_photoProfile>
            </div_body>
        </div>
    );
}

export default LoginForm;
